import { combineReducers, configureStore, ThunkMiddleware, Tuple } from '@reduxjs/toolkit'
import  { reducerSlice } from './reducer';
import { postMessageToAdpBridge } from '../hooks/useIPCBridge';
import { indexDBStorage } from '../storage/indexDBStorage';
import { IADPState } from '../typings/AppStateTypes';
import { LoggPrefix } from '../util/constants';
import { npnReducerSlice } from '../../npn/state/reducer';
import { internetReducerSlice } from '../../internet/state/reducer';
import { INPNState } from '../../npn/state/initialState';


const storeInIndexDB: ThunkMiddleware<{rootState:IADPState,npnAppState:INPNState}> =
  ({ getState }) =>
  next =>
  action => {
    const returnValue = next(action);
    const state = {
      ...getState().rootState,npnAppState:getState().npnAppState?.npnAppState,npnFlow:getState().npnAppState?.npnFlow}
    console.log(LoggPrefix,returnValue,'state after dispatch', state);
    indexDBStorage.getInstance().then(async (instance:any)=>{
      if(state.appState.currentView === "LoadingView")return returnValue;
      if(state.appState.appLaunchId) {
        //TODO - create middleware for all indexDB updates
        const instance =  await indexDBStorage.getInstance();
        //console.log("appState.appState.appLaunchId",state.appState.appLaunchId)
        instance.transactions.put("adp-session-references",state.appState.appLaunchId,"clientLaunchId");
      }
      else return returnValue;
      const storeToPersist = {
        clientLaunchId: state.appState.appLaunchId,
        appState: state.appState,
        cacheState: {...state.serviceWorkers,...state.cacheValidation},
        deviceReadinessState: {...state.deviceReadinessState,deviceValidationSummary:state.deviceReadinessSummary},
        deviceState: state.deviceState,
        sessionState: {...state.sessionState, selectedAssessmentMode: state.sessionState.selectedAssessmentMode.toLowerCase()},
        updateState: state.updateState,
        staticContent:state.staticContent,
        npnAppState: state.npnAppState,
        npnFlow:state.npnFlow
      }
      
      /**
       * store pwa state in IndexDB under the eNAEP domain
       * e.g npd-ng-adp-storage-v2 - https://enaep.dev24.npdng.org/
       * Environment specific storages will be created
       */
      instance.transactions.put("adp-state-indexed",storeToPersist);
       /**
       * post adp pwa stat to chrome extension to persist in indexDB under the Chrome extension domain
       * e.g npd-ng-adp-storage-v2 - chrome-extension://cmgaklaggiapjhkgfehhcgbgilogdmmm/
       * Chrome extension will take care of posting the diagnostic data in NCS mode
       */
      postMessageToAdpBridge({
          type: "PostChromeAppState",
          data: storeToPersist
        });
     });
    // This will likely be the action itself, unless
    // a middleware further in chain changed it.
    return returnValue
  }
  const rootReducer = combineReducers({
    rootState: reducerSlice.reducer,
    npnAppState: npnReducerSlice.reducer,
    internetReducerSlice: internetReducerSlice.reducer
  });  
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => new Tuple(storeInIndexDB)
})

export default store